import styled from 'styled-components';
import { PromoCodeStyled } from '../PromoCodeStyled';
import { rem } from 'polished';

export const PromoCodeStyledDS = styled(PromoCodeStyled)`
    background: ${({ theme }) => theme.colors.cream};

    .promoCode {
        &__title {
            color: ${({ theme }) => theme.colors.black};
            font-size: ${rem(18)};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
        }

        &__input_label_success {
            width: 70%;
            left: 15%;
            background: ${({ theme }) => theme.colors.success};
            color: ${({ theme }) => theme.colors.white};

            &::after {
                border-top: 7px solid ${({ theme }) => theme.colors.success};
            }
        }

        &__input {
            border: 1px solid ${({ theme }) => theme.colors.grey5};
            color: ${({ theme }) => theme.colors.accordionAnswer};

            &_error {
                border-color: ${({ theme }) => theme.colors.danger};
            }
        }

        &__button {
            border: 1px solid ${({ theme }) => theme.colors.primary};
            color: ${({ theme }) => theme.colors.primary};
            font-size: ${rem(14)};

            &:hover {
                color: ${({ theme }) => theme.colors.white};
                background: ${({ theme }) => theme.colors.primary};
            }
        }
    }
`;
